import { render } from "./ClientsListDeleteModal.vue?vue&type=template&id=5dd3c882"
import script from "./ClientsListDeleteModal.vue?vue&type=script&lang=js"
export * from "./ClientsListDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__